import * as tslib_1 from "tslib";
import { AbstractPlatform } from '@app/platform/platform';
var WebPlatform = /** @class */ (function (_super) {
    tslib_1.__extends(WebPlatform, _super);
    function WebPlatform() {
        var _this = _super.call(this) || this;
        _this.panelEnabledChange$.next(true);
        return _this;
    }
    // TODO Remove when restartApp is used everywhere
    WebPlatform.prototype.reboot = function () {
        return this.restartApp();
    };
    WebPlatform.prototype.restartApp = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                window.location.reload();
                return [2 /*return*/];
            });
        });
    };
    WebPlatform.prototype.getAppUpdateUrl = function () {
        return window.location.host;
    };
    // TODO Remove when getAppUptime is used everywhere
    WebPlatform.prototype.getSystemUptime = function () {
        return this.getAppUptime();
    };
    return WebPlatform;
}(AbstractPlatform));
export { WebPlatform };
